(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yst-hover-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yst-hover-video') && 'IntersectionObserver' in window) {
  const desktop = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const cards = new Set();
  const active = new Set();
  const mobileSources = new Map();
  let suspended = false;

  const allowed = () => !document.hidden && !suspended &&
    !reduced.matches && !connection?.saveData;
  const mobileAllowed = () => allowed() && !desktop.matches &&
    !['slow-2g', '2g'].includes(connection?.effectiveType);

  function schedule() {
    if (!mobileAllowed()) return;
    for (const card of cards) {
      if (card.isConnected && card.ratio >= 0.6 && !card.mobileDone &&
          !card.failed && !active.has(card)) card.begin(true);
    }
  }

  function reset() {
    for (const card of [...active]) card.stop();
    schedule();
  }

  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const card = entry.target;
      card.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
      if (card.ratio < 0.15) card.mobileDone = false;
      if (active.has(card) && (card.ratio === 0 ||
          (card.mobile && card.ratio < 0.35))) card.stop();
    }
    schedule();
  }, { threshold: [0, 0.15, 0.35, 0.6, 1] });

  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', reset);
  desktop.addEventListener('change', reset);
  reduced.addEventListener('change', reset);
  connection?.addEventListener('change', reset);
  window.addEventListener('pagehide', () => {
    suspended = true;
    reset();
  });
  window.addEventListener('pageshow', () => {
    suspended = false;
    schedule();
  });

  customElements.define('yst-hover-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.link = this.closest('a');
      if (!this.video || !this.link) return;
      this.ratio = 0;
      this.token = 0;
      this.mobileDone = false;
      this.failed = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      cards.add(this);
      observer.observe(this);

      const enter = () => {
        if (!desktop.matches || !allowed()) return;
        if (this.isConnected && this.ratio > 0) this.begin(false);
      };
      const leave = () => {
        if (!this.mobile) this.stop();
      };
      this.link.addEventListener('pointerenter', enter, options);
      this.link.addEventListener('pointerleave', leave, options);
      this.link.addEventListener('focus', enter, options);
      this.link.addEventListener('blur', leave, options);
      this.link.addEventListener('click', () => {
        this.mobileDone = true;
        this.stop();
      }, options);
      this.video.addEventListener('playing', () => {
        if (!active.has(this) || !allowed()) return this.stop();
        clearTimeout(this.loadTimer);
        this.setAttribute('data-playing', '');
        this.dataset.state = 'playing';
        if (this.mobile && !this.previewTimer) {
          this.mobileDone = true;
          this.previewTimer = setTimeout(() => this.stop(), 4000);
        }
      }, options);
      this.video.addEventListener('ended', () => {
        if (this.mobile) this.stop();
      }, options);
      this.video.addEventListener('error', () => {
        if (active.has(this)) {
          this.failed = true;
          this.dataset.state = 'media-error';
          this.stop();
        }
      }, options);
    }

    async mobileSource(signal) {
      const key = this.dataset.productHandle + ':' + this.dataset.mediaId;
      if (mobileSources.has(key)) return mobileSources.get(key);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'products/' +
        encodeURIComponent(this.dataset.productHandle) + '.js',
        { signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product metadata unavailable');
      const product = await response.json();
      const media = product.media?.find(item => String(item.id) === this.dataset.mediaId);
      const sources = (media?.sources || []).filter(source =>
        source.format === 'mp4' && source.width > 0 && source.height > 0);
      sources.sort((a, b) => a.width * a.height - b.width * b.height);
      if (!sources[0]?.url) throw new Error('Preview source unavailable');
      mobileSources.set(key, sources[0].url);
      return sources[0].url;
    }

    async begin(mobile) {
      if (!allowed() || this.failed || active.has(this)) return;
      if (mobile && (!mobileAllowed() || this.ratio < 0.6 || this.mobileDone)) return;
      if (!mobile) for (const card of [...active]) card.stop();
      active.add(this);
      this.mobile = mobile;
      const token = ++this.token;
      this.request = new AbortController();
      this.dataset.state = 'loading';
      this.loadTimer = setTimeout(() => {
        this.mobileDone = true;
        this.dataset.state = 'timeout';
        this.stop();
      }, 10000);
      try {
        const src = mobile ? await this.mobileSource(this.request.signal) : this.dataset.src;
        if (token !== this.token || !this.isConnected || !allowed() ||
            (mobile && (!mobileAllowed() || this.ratio < 0.35))) return;
        if (!src) throw new Error('Preview source unavailable');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.video.loop = !mobile;
        this.video.src = src;
        await this.video.play();
      } catch (error) {
        if (token !== this.token) return;
        this.failed = true;
        this.dataset.state = error.name === 'NotAllowedError' ? 'autoplay-blocked' : 'source-error';
        this.stop();
      }
    }

    stop() {
      ++this.token;
      clearTimeout(this.previewTimer);
      clearTimeout(this.loadTimer);
      this.previewTimer = null;
      this.request?.abort();
      active.delete(this);
      this.removeAttribute('data-playing');
      this.video?.pause();
      if (this.video?.hasAttribute('src')) {
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.dataset.state === 'playing' || this.dataset.state === 'loading') {
        this.dataset.state = 'idle';
      }
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      observer.unobserve(this);
      cards.delete(this);
      schedule();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
